import Nullstack from 'nullstack';
export default function IconChessRook({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-chess-rook",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M8 16l-1.447 .724a1 1 0 0 0 -.553 .894v2.382h12v-2.382a1 1 0 0 0 -.553 -.894l-1.447 -.724h-8z"
  }), "   ", Nullstack.element("path", {
    d: "M8 16l1 -9h6l1 9"
  }), "   ", Nullstack.element("path", {
    d: "M6 4l.5 3h11l.5 -3"
  }), "   ", Nullstack.element("path", {
    d: "M10 4v3"
  }), "   ", Nullstack.element("path", {
    d: "M14 4v3"
  }), " ");
}